import { Box, Button } from "@saleor/macaw-ui-next";
import { useIntl } from "react-intl";
import { Link } from "react-router-dom";

import { sectionMessages } from "../../messages";
import {
  atticIntakePath,
  atticLedgerPath,
  atticLocationListPath,
  atticLotListPath,
  atticStockLookupPath,
} from "../../urls";

export type AtticInventoryTab = "stock" | "locations" | "lots" | "intake" | "ledger";

const TABS: Array<{
  id: AtticInventoryTab;
  path: string;
  label: "stockLookup" | "locations" | "lots" | "intake" | "ledger";
}> = [
  { id: "stock", path: atticStockLookupPath, label: "stockLookup" },
  { id: "locations", path: atticLocationListPath, label: "locations" },
  { id: "lots", path: atticLotListPath, label: "lots" },
  { id: "intake", path: atticIntakePath, label: "intake" },
  { id: "ledger", path: atticLedgerPath, label: "ledger" },
];

/**
 * The five pages of the section as a row of links under the TopNav. The
 * current one is primary; the rest are secondary.
 */
export const AtticInventoryNav = ({ current }: { current: AtticInventoryTab }) => {
  const intl = useIntl();

  return (
    <Box
      as="nav"
      display="flex"
      gap={2}
      flexWrap="wrap"
      paddingX={6}
      paddingBottom={4}
      data-test-id="attic-inventory-nav"
    >
      {TABS.map(tab => (
        <Link key={tab.id} to={tab.path} aria-current={tab.id === current ? "page" : undefined}>
          <Button
            as="span"
            variant={tab.id === current ? "primary" : "secondary"}
            size="small"
            data-test-id={`attic-inventory-nav-${tab.id}`}
          >
            {intl.formatMessage(sectionMessages[tab.label])}
          </Button>
        </Link>
      ))}
    </Box>
  );
};
